module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group', {
    staticStyle: {
      "border-top": "0",
      "margin-top": "10px"
    },
    attrs: {
      "label-width": "2.5rem",
      "label-margin-right": "2em",
      "label-align": "right",
      "gutter": "0"
    }
  }, [_c('cell', {
    staticClass: "cell-height",
    attrs: {
      "value-align": "left",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getupvalue($event)
      }
    }
  }, [_c('img', {
    staticClass: "cell-lable-right",
    attrs: {
      "slot": "icon",
      "width": "22",
      "src": require("../../assets/img/jjAirplane.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-fontSize",
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_c('p', {
    style: (_vm.yz(_vm.upvalue))
  }, [_c('span', {
    staticStyle: {
      "color": "#0d87e4"
    }
  }, [_vm._v(_vm._s(_vm.upvalue.address ? '[当前]' : ''))]), _vm._v("\n                    " + _vm._s(_vm.upvalue.address ? (_vm.upvalue.address.length > 20 ? _vm.upvalue.address.substr(0, 10) : _vm.upvalue.address) : '请设置出发地点') + "\n                ")])])]), _vm._v(" "), _c('cell', {
    staticClass: "cell-height",
    attrs: {
      "value-align": "left",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getdownvalue($event)
      }
    }
  }, [_c('img', {
    staticClass: "cell-lable-right",
    attrs: {
      "slot": "icon",
      "width": "22",
      "src": require("../../assets/img/jjLast.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-fontSize",
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_c('span', {
    style: (_vm.yz(_vm.downvalue))
  }, [_vm._v(_vm._s(_vm.downvalue ? _vm.downvalue.siteName : '请选择到达机场'))])])])], 1), _vm._v(" "), _c('group', {
    staticClass: "no_borderBottom",
    staticStyle: {
      "border-top": "0",
      "margin-top": "10px"
    },
    attrs: {
      "label-width": "3rem",
      "label-margin-right": "2em",
      "label-align": "right",
      "gutter": "0"
    }
  }, [_c('datePick', {
    attrs: {
      "list": _vm.list3,
      "upvalue": _vm.upvalue,
      "downvalue": _vm.downvalue,
      "label": "1"
    },
    model: {
      value: (_vm.jsDate),
      callback: function($$v) {
        _vm.jsDate = $$v
      },
      expression: "jsDate"
    }
  }), _vm._v(" "), _c('personPick', {
    attrs: {
      "upvalue": _vm.upvalue,
      "downvalue": _vm.downvalue,
      "personList": _vm.personList
    },
    on: {
      "callPrice": _vm.callPrice
    },
    model: {
      value: (_vm.jsPerson),
      callback: function($$v) {
        _vm.jsPerson = $$v
      },
      expression: "jsPerson"
    }
  }), _vm._v(" "), _c('choosePerson', {
    attrs: {
      "urlFlag": "giveawayAircraft"
    },
    model: {
      value: (_vm.jsPassanger),
      callback: function($$v) {
        _vm.jsPassanger = $$v
      },
      expression: "jsPassanger"
    }
  })], 1), _vm._v(" "), _c('group', {
    staticStyle: {
      "border-top": "0",
      "margin-top": "10px"
    },
    attrs: {
      "label-width": "4.5em",
      "label-margin-right": "2em",
      "label-align": "right",
      "gutter": "0"
    }
  }, [_c('div', {
    staticClass: "price-bar"
  }, [_c('div', {
    staticClass: "price-content"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.8rem",
      "margin-right": ".2rem"
    }
  }, [_vm._v(_vm._s(_vm.payPrice ? _vm.payPrice : "0.00"))]), _vm._v("元\n                "), _c('badge', {
    class: _vm.activityName ? 'top-bar top-bar-jz' : 'top-bar top-bar-sz',
    attrs: {
      "text": _vm.activityName ? _vm.activityName : '专车接驾'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "commitBtn"
  }, [_c('x-button', {
    staticStyle: {
      "background": "#0d87e4",
      "font-size": ".85rem",
      "padding": "4px 0"
    },
    attrs: {
      "type": "primary",
      "action-type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            确认预约\n        ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "1rem"
    }
  }, [_c('p', [_c('icon', {
    staticStyle: {
      "font-size": "16px",
      "color": "#0d87e4",
      "vertical-align": "sub"
    },
    attrs: {
      "type": _vm.checkBoxValue
    },
    nativeOn: {
      "click": function($event) {
        _vm.checkBoxFlag = !_vm.checkBoxFlag
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.showAgree = true
      }
    }
  }, [_vm._v("接送机服务须知")])], 1)]), _vm._v(" "), _c('Agreement', {
    attrs: {
      "showScrollBox": _vm.showAgree,
      "data": _vm.ProtocolDetail
    },
    model: {
      value: (_vm.showAgree),
      callback: function($$v) {
        _vm.showAgree = $$v
      },
      expression: "showAgree"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ed34571"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickGiveAircraft/giveawayAircraft.vue
// module id = 411
// module chunks = 1